import interbanking from "../img/ib_pago.png";
import bna from "../img/bna_pago.png";
import pagomiscuentas from "../img/pagomiscuentas.png";
import linkpagos from "../img/linkpagos.png";
import pagar from "../img/pagar-red_link.png";
import mercadopago from "../img/mp_pago.png";
import pagofacil from "../img/pf_pago.png";
import rapipago from "../img/rapipago.png";
import banelco from "../img/banelco.png";
import chrome from "../img/chrome.svg";
const PayMethods =()=> {
    
    return(
        <div>
            <br/>
            
            
            <div>
                <img className="img-fluid mb-2" src={chrome} alt="Usar Chrome para descargar boleta con código de barras" title="Usar Chrome para descargar boleta con código de barras" width={29}/>
                <span className="text-muted mx-3">Se recomienda utilizar Chrome para asegurar la lectura del código de barras</span>
            </div>
            <br/>
            <hr className="text-secondary"></hr>
            <h3>Medios de pago disponibles</h3>
            <br/><br/>
            <div className="row">
                <div className="col-md-2">
                    <img src={pagar} alt="Pagar - Red Link" width={150}/>
                </div>
                <div className="col-md-2">
                    <img src={banelco} alt="pagomiscuentas - Banelco" width={150}/>
                </div>
                <div className="col-md-2">
                    <img src={bna} alt="BNA" width={150}/>
                </div>
                <div className="col-md-2">
                    <img src={interbanking} alt="Interbanking" width={150}/>
                </div>
                <div className="col-md-2">
                    <img src={mercadopago} alt="Mercado Pago" width={150}/>
                </div>
                <div className="col-md-2">
                    <img src={pagofacil} alt="Pago Facil" width={150}/>
                </div>    
            </div>            
            <br/>
            <br/>
            <h6><strong>IMPORTANTE: NO SE ACEPTAN TRANSFERENCIAS BANCARIAS</strong></h6>
            <div>&nbsp;</div>
            <hr className="text-secondary"></hr>
            <br/>
            
            <br/>
            <br/>
            <br/>
        </div>
    );
}

export default PayMethods;